import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Chief Financial Officer section for selections tab
 */
const ChiefFinancialofficerSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="chief-financial-officer-section-component"
    >
      <AccordionV2
        testId="chief-financial-officer"
        className="border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Chief Financial Officer" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            The selection for this Award goes through a three-stage process:
          </p>

          <p>
            In Stage 1, likely candidates will be identified through the
            following sources:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Nominations;</li>

            <li>Media reports and industry knowledge;</li>

            <li>
              Rankings of the CEO companies in the ASEAN Corporate Governance
              Scorecard and the Singapore Governance and Transparency Index;
            </li>

            <li>Performance of the CEO companies;</li>
          </ul>

          <p>
            In stage 2, additional research and inputs on shortlisted CFOs are
            conducted through research and discreet inquiries. A final shortlist
            is then drawn up using the criteria (described below) for the judges
            to assess in stage 3.
          </p>

          <p>
            In stage 3, a panel of judges will use information obtained from
            earlier stages, review and evaluate the final shortlist of
            candidates. The Judging Panel will decide the winners for each
            category.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ChiefFinancialofficerSection;
